<template>
  <div class="modal-wrapper">
    <div class="modal-pay">
      <div class="modal-title">
        <h2>보유포인트</h2>
        <!-- <h4></h4> -->
        <a class="close-btn" @click="$emit('close', null)"><img src="@/assets/img/icon_cancel.svg" /></a>
      </div>
      <div class="modal-content">
        <ul class="modal-info">
          <li>
            <span>아이디 : </span>
            <span>{{selectMem.memId}}</span>
          </li>
          <li>
            <span>닉네임 : </span>
            <span>{{selectMem.memNick}}</span>
          </li>
          <li>
            <span>현재 보유 캐시 : </span>
            <span>{{thousand(selectMem.pointAmt)}}</span>
          </li>
          <li>
            <span>처리 머니 : </span>
            <span class="inputWrap">
              <input id="cashInput" type="text" v-model="newPoint">
              <!-- <label for="cashInput"></label> -->
            </span>
          </li>
        </ul>
        <div class="modal-btns">
          <a @click="setPoint('in')">지급</a>
          <a @click="setPoint('out')">회수</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { thousand } from '@/libs/utils'
import { memberPointInOut } from '@/api/cash'

export default {
  name: 'PayPointModal',
  watch: {
    newPoint () {
      const parts = this.newPoint.split('.')
      const v = parts[0].replace(/\D/g, '')
      const dec = parts[1]
      // const calcNum = Number((dec !== undefined ? v + '.' + dec : v))
      let n = new Intl.NumberFormat('en-EN').format(v)
      n = dec !== undefined ? n + '.' + dec : n
      this.newPoint = n
    }
  },
  methods: {
    thousand,
    async setPoint (type) {
      if (!this.newPoint || this.newPoint === '0') {
        alert('포인트을 입력해주세요.')
      } else {
        const point = Number(this.newPoint.replace(/,/g, ''))
        if (type === 'in') {
          const cfval = confirm('지급처리하시겠습니까?')
          if (cfval) {
            const req = {
              memId: this.selectMem.memId,
              pointType: 2,
              pointDesc: '관리자 포인트 지급',
              pointAmt: point,
              memo: ''
            }
            const res = await memberPointInOut(req)
            if (res.resultCode === '0') {
              this.emitter.emit('ChangePay')
              alert('지급완료')
              this.resultPoint = this.selectMem.pointAmt + point
              this.$emit('close', this.resultPoint, this.selectIdx)
            } else {
              alert('지급실패, 다시 시도해주세요.')
            }
          }
        } else {
          const cfval = confirm('회수처리하시겠습니까?')
          if (cfval) {
            const req = {
              memId: this.selectMem.memId,
              pointType: -2,
              pointDesc: '관리자 포인트 회수',
              pointAmt: point * -1,
              memo: ''
            }
            const res = await memberPointInOut(req)
            if (res.resultCode === '0') {
              this.emitter.emit('ChangePay')
              alert('회수 완료')
              this.resultPoint = this.selectMem.pointAmt - point
              this.$emit('close', this.resultPoint, this.selectIdx)
            } else {
              alert('회수실패, 다시 시도해주세요.')
            }
          }
        }
        this.newPoint = '0'
        // this.resultCash = 0
      }
    }
  },
  data () {
    return {
      newPoint: '0',
      resultPoint: 0
    }
  },
  props: [
    'selectMem',
    'selectIdx'
  ]
}
</script>

<style scoped>
  .modal-wrapper {
    justify-content: center;
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
    background: rgba(0, 0, 0, .4196078431372549);
  }
  .modal-pay {
    width: 385px;
    min-width: 385px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 1px solid #c1c1c1;
    box-shadow: 6px 6px 6px 0 rgba(0, 0, 0, .16);
    padding: 15px 25px;
    background: #fafafa;
    box-sizing: border-box;
  }
  .modal-title {
    color: #646464;
    font-size: 13px;
    padding-bottom: 11px;
    border-bottom: 2px solid #959595;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .modal-title h2 {
    letter-spacing: -.39px;
    font-weight: 800;
  }
  .modal-title .close-btn {
    display: flex;
    align-items: center;
    width: 20px;
    height: 20px;
    color: #646464;
    cursor: pointer;
  }
  .modal-title .close-btn img {
    width: 100%;
  }
  .modal-content {
    padding-top: 10px;
    color: #343434;
    font-size: 12px;
  }
  .modal-info {
    flex-direction: column;
    gap: 10px;
  }
  .modal-info, .modal-info li {
    display: flex;
  }
  .modal-info li {
    align-items: center;
    gap: 5px;
  }
  .modal-btns, .modal-btns a {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .modal-btns {
    gap: 10px;
    margin-top: 18px;
  }
  .modal-btns a {
    width: 90px;
    height: 26px;
    border-radius: 2px;
    border: 1px solid #646464;
    box-sizing: border-box;
    background-color: #fafafa;
    font-size: 13px;
    color: #343434;
    cursor: pointer;
  }
  .inputWrap {
    position: relative;
  }
  #cashInput {
    width: 110px;
    height: 20px;
    color: transparent;
    background-color: transparent;
    border: 1px solid #000;
    color: #000;
    border-radius: 0;
    position: relative;
    z-index: 1;
  }
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  #cashInput+label {
    font-size: 12px;
    background: #fff;
    color: #000;
    height: 20px;
    padding: 0 6px;
    box-sizing: border-box;
    width: 110px;
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
</style>
